import { mainSiteUrl, externalLinkAttrs } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20wardrobe%20hallway%20with%20open%20shelves%20displaying%20folded%20clothing%20stacks%20and%20accessories%2C%20warm%20indirect%20lighting%20from%20recessed%20LED%20strips%2C%20luxury%20walk-in%20closet%20interior%2C%20clean%20modern%20design%2C%20rich%20wood%20textures%20and%20cream%20fabrics%2C%20aspirational%20lifestyle%20photography&width=1800&height=900&seq=cta-bg-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet luxury wardrobe inspiration"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/45"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col justify-between px-8 md:px-16 py-12 md:py-16">
        <div>
          <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-none lowercase">
            sugargoo<br />spreadsheet
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8">
          <a
            href={mainSiteUrl}
            {...externalLinkAttrs}
            className="group inline-flex items-center gap-3 px-6 py-3 rounded-full border-2 border-white text-white text-sm md:text-base font-semibold hover:bg-white hover:text-foreground-950 transition-all whitespace-nowrap"
          >
            <span>Buy It Now</span>
            <span className="w-5 h-5 flex items-center justify-center rounded-full bg-white group-hover:bg-foreground-950 transition-colors">
              <i className="ri-arrow-right-line text-xs text-foreground-950 group-hover:text-white transition-colors"></i>
            </span>
          </a>

          <p className="text-white/60 text-xs md:text-sm leading-relaxed max-w-xs text-right">
            All external links open in new tabs.<br />
            Happy shopping with verified sellers.
          </p>
        </div>
      </div>
    </section>
  );
}